const ShimmerOrderDetails = () => {
  return (
    <div className="animate-pulse">
      <div className="mx-auto w-full max-w-7xl px-4 py-8 sm:px-6">
        
        {/* Steps */}
        <div className="mb-5 grid grid-cols-1 gap-2 sm:grid-cols-3">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="h-10 rounded-lg bg-slate-200"></div>
          ))}
        </div>

        <div className="grid grid-cols-1 gap-5 xl:grid-cols-[1.1fr_1fr]">
          
          {/* Left Form */}
          <div className="rounded-2xl bg-white p-5 space-y-4">
            <div className="h-6 w-1/3 bg-slate-200 rounded"></div>
            <div className="h-4 w-1/2 bg-slate-200 rounded"></div>

            {[...Array(5)].map((_, i) => (
              <div key={i} className="space-y-2">
                <div className="h-4 w-24 bg-slate-200 rounded"></div>
                <div className="h-10 w-full bg-slate-200 rounded"></div>
              </div>
            ))}
          </div>

          {/* Right Order Summary */}
          <div className="rounded-2xl bg-slate-800 p-5 space-y-4">
            <div className="h-6 w-1/2 bg-slate-600 rounded"></div>
            <div className="h-4 w-2/3 bg-slate-600 rounded"></div>

            {/* Items */}
            {[...Array(4)].map((_, i) => (
              <div key={i} className="flex gap-3 bg-white/10 p-2 rounded">
                <div className="h-12 w-12 bg-slate-600 rounded"></div>
                <div className="flex-1 space-y-2">
                  <div className="h-3 w-3/4 bg-slate-600 rounded"></div>
                  <div className="h-3 w-1/2 bg-slate-600 rounded"></div>
                </div>
              </div>
            ))}

            {/* Delivery */}
            <div className="space-y-2">
              {[...Array(3)].map((_, i) => (
                <div key={i} className="h-10 bg-slate-600 rounded"></div>
              ))}
            </div>

            {/* Price */}
            <div className="space-y-2">
              <div className="h-4 w-full bg-slate-600 rounded"></div>
              <div className="h-4 w-full bg-slate-600 rounded"></div>
              <div className="h-5 w-full bg-slate-600 rounded"></div>
            </div>

            {/* Button */}
            <div className="h-10 w-full bg-slate-600 rounded"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShimmerOrderDetails;